var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTooltipUpFrontFee = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)",
  fill: "#7A8189"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8 .664C3.956.664.667 3.954.667 7.997c0 4.044 3.29 7.334 7.333 7.334 4.044 0 7.333-3.29 7.333-7.334 0-4.043-3.29-7.333-7.333-7.333Zm0 13.333c-3.308 0-6-2.691-6-6 0-3.308 2.692-6 6-6 3.309 0 6 2.692 6 6 0 3.309-2.691 6-6 6Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 6.883a.667.667 0 0 0-.667.666v4a.667.667 0 0 0 1.334 0v-4A.667.667 0 0 0 8 6.883ZM8 3.773a.89.89 0 0 0 0 1.778.89.89 0 0 0 0-1.778Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));
export default SvgTooltipUpFrontFee;